import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { endpoints, getIDFromUrl, Url } from '@rossum/api-client';
import { useApiClient } from '../../../lib/apiClient';
import { userHookStateSelector } from '../../../redux/modules/user/selectors';
import { notify } from '../../toaster';

export const useInvokeHook = () => {
  const api = useApiClient();
  const location = useLocation();
  const hookState = useSelector(userHookStateSelector);
  const intl = useIntl();

  return useMutation({
    onSuccess: () =>
      notify.default({
        title: intl.formatMessage({
          id: 'containers.settings.extensions.createExtension.events.invoke.success',
        }),
      }),
    onError: error => {
      const message =
        error instanceof Error
          ? error.message
          : typeof error === 'string'
            ? error
            : undefined;

      notify.error({
        title: intl.formatMessage(
          {
            id: 'containers.settings.extensions.createExtension.events.invoke.error',
          },
          { error: message }
        ),
      });
    },
    mutationFn: ({
      hook,
      payload,
    }: {
      hook: Url;
      payload?: Record<string, unknown> | undefined;
    }) =>
      api.request(
        endpoints.hooks.invoke(getIDFromUrl(hook), {
          ...payload,
          location,
          user_state: hookState,
        })
      ),
  });
};
